module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAATpJREFUOE9jZKAyYMRlXkHzZU0WLsm1DIzM0shqGP8zPPr17WXIxFqNm9j04jSwuOdFDTOrUDM2Tf9+vavpKZVoJcnAkt7X9Uws/A1YDfzzsaGnWLSRvgZmtzyTZ2D6zg6x9ddbTnaRHLJdWNzz6igzq4AVwguMDf/+fGAg28DSCd//MzIyIwUJY+O/Px/+k21g2cRf/1ED+H/zvz+f/tLVwH9/fu5kZPxnCXPIj19f1k2t0XoITofkuJCJRYCBgeE/PFn9//PtRXexgCTVDAQ5rCufjXHUQFicEU426JFC2zAsnfDtLyMjCxNS1iOYUzCSzf8//7sLuJjAsVzc9aKVkZktg4GRkQXEZ2RgbP/35/M/RmbuamxF1P+/X1uZWHiZ/jP8rwTL////6//fbzN6y2RqcRaw5NYMAJbJACS2Gi16AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/activation_sj.png
// module id = JkF5
// module chunks = 57